module.exports = __webpack_public_path__ + "img/HoveredMediumIcon.a364ae88.svg";